module.exports = __webpack_public_path__ + "img/card_informe_satisfaction-questionnaire.1fe439da.svg";